/* --------------------------------------------------------------------------------------
   scanPreview.component.js
   Copyright © 2019 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const scanPreviewComponent = {
  template: require("./scanPreview.html"),
  controllerAs: "vm",
  bindings: {
    display: "=",
    previews: "=",
    onAccepted: "&",
    onCancel: "&",
  },
  controller: class scanPreviewCtrl {
    /* @ngInject */
    constructor(commonService, deviceInfoService, $sanitize) {
      this.deviceInfoService = deviceInfoService;
      this.commonService = commonService;
      this.$sanitize = $sanitize;
    }

    async $onInit() {
      this.alta = this.commonService.isAltalink();
    }

    // async $onChanges() {
    //   if (this.previews && this.previews.length) {
    //     await this.commonService.updateView();
    //     angular.element("#scan-preview-alert").xrxpopup("open");
    //   }
    // }

    setScroll() {
      angular.element("#scan-preview-single-img-container").xrxscrollable();
    }

    close() {
      if (this.selectedImg) this.selectedImg = null;
      else {
        this.previews = null;
        return this.onCancel();
      }
    }

    accept() {
      this.previews = null;
      return this.onAccepted();
    }

    selectedCount() {
      if (!this.previews) return 0;
      return this.previews.filter((prev) => prev.selected).length;
    }

    selectAll() {
      this.previews.forEach((prev) => (prev.selected = true));
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/scan/components/scanPreview.component.js